/** @readonly Application shell routes */
export const APP_ROUTES = Object.freeze({
  ROOT: '/r',
  LOGIN: '/r/login',
  NOT_FOUND: '/r/404',
  ACCESS_DENIED: '/r/access-denied',
});
